// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"2ef96bf9","453":"c9f6761d"}[chunkId] + ".chunk.js";
};